import React from "react";
import { Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { MdTranslate } from "react-icons/md";
import { useTranslation } from "react-i18next";

/**
 * Minimal “translate” control: icon + bold label, no pill/border (matches reference UI).
 */
export default function LanguageMenuTrigger({ onClick, display, iconBoxSize = "22px", ...rest }) {
  const { t } = useTranslation();
  const color = useColorModeValue("gray.900", "white");
  const hoverBg = useColorModeValue("blackAlpha.50", "whiteAlpha.100");

  return (
    <Flex
      as="button"
      type="button"
      align="center"
      gap={2}
      px={1}
      py={1}
      borderRadius="md"
      bg="transparent"
      border="none"
      cursor="pointer"
      color={color}
      onClick={onClick}
      _hover={{ bg: hoverBg }}
      _active={{ bg: hoverBg }}
      display={display}
      lineHeight={1}
      {...rest}
    >
      <Icon as={MdTranslate} boxSize={iconBoxSize} flexShrink={0} aria-hidden />
      <Text as="span" fontWeight="bold" fontSize="sm" letterSpacing="-0.01em">
        {t("common.language")}
      </Text>
    </Flex>
  );
}
